<div class="test wd-100">
  <app-page-loader></app-page-loader>
  <router-outlet></router-outlet>
  @if (displayFlag) {
  <app-session-timeout (continueWithMySession)="extendSessionHandler()" (sessionLogout)="expireSessionHandler()"
    [userDetails]="loginDetails"></app-session-timeout>
  }
  @if (isLocked) {
  <app-modal [modalConfig]="lockedAlertModalConfig" (closeModal)="closeLockedModal()"
    (primaryBtnClick)="closeLockedModal()" [saveDataFlag]="false">
  </app-modal>
  }
</div>